import { render, staticRenderFns } from "./EntityName.vue?vue&type=template&id=5efc86c3"
import script from "./EntityName.vue?vue&type=script&lang=ts"
export * from "./EntityName.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports